/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from './index-892d8eee.js';

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function promisify(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends$1({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }

          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }

          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }

          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }

          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SHORT_DELAY = 2000; // 2 seconds

function styleOptions(options) {
  var DEFAULT_REQUEST_OPTIONS = {
    content: '',
    type: 'none',
    duration: SHORT_DELAY
  };

  if (typeof options === 'string') {
    return _extends({}, DEFAULT_REQUEST_OPTIONS, {
      content: options
    });
  } else {
    return _extends({}, DEFAULT_REQUEST_OPTIONS, options);
  }
}
function normalize(api) {
  return function (options) {
    var afterOptions = styleOptions(options);
    return promisify(api)(afterOptions);
  };
}

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

var show$6 = normalize(function (options) {
  var type = options.type,
      content = options.content,
      duration = options.duration,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var showToast = isDingdingMiniapp ? dd.showToast : my.showToast;
  showToast({
    type: type,
    content: content,
    duration: duration,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
});
var showToast$5 = show$6;

var hide$5 = normalize(function (options) {
  var hideToast = isDingdingMiniapp ? dd.hideToast : my.hideToast;
  hideToast(options);
});
var hideToast$6 = hide$5;

var aliMiniAppModule = {
  show: showToast$5,
  hide: hideToast$6,
  showToast: showToast$5,
  hideToast: hideToast$6
};

var show$5 = normalize(function (options) {
  var type = options.type,
      content = options.content,
      duration = options.duration,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var iconMap = {
    success: 'success',
    fail: 'error',
    none: 'none',
    loading: 'loading'
  };
  wx.showToast({
    icon: iconMap[type] || '',
    title: content,
    duration: duration,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
});
var showToast$4 = show$5;

var hide$4 = normalize(function (options) {
  wx.hideToast(options);
});
var hideToast$5 = hide$4;

var weChatModule = {
  show: showToast$4,
  hide: hideToast$5,
  showToast: showToast$4,
  hideToast: hideToast$5
};

var show$4 = normalize(function (options) {
  var type = options.type,
      content = options.content,
      duration = options.duration,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var iconMap = {
    success: 'success',
    fail: 'fail',
    none: 'none',
    loading: 'loading'
  };
  tt.showToast({
    icon: iconMap[type] || 'none',
    title: content,
    duration: duration,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
});
var showToast$3 = show$4;

var hide$3 = normalize(function (options) {
  tt.hideToast(options);
});
var hideToast$4 = hide$3;

var bytedanceModule = {
  show: showToast$3,
  hide: hideToast$4,
  showToast: showToast$3,
  hideToast: hideToast$4
};

/* eslint-disable guard-for-in */
var styles = {
  container: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    boxSizing: 'border-box',
    maxWidth: '80%',
    color: '#ffffff',
    padding: '8px 16px',
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    left: '50%',
    bottom: '50%',
    fontSize: '16px',
    lineHeight: '32px',
    fontWeight: '600',
    borderRadius: '4px',
    textAlign: 'center',
    transition: 'all 0.4s ease-in-out',
    webkitTransition: 'all 0.4s ease-in-out',
    transform: 'translateX(-50%)',
    webkitTransform: 'translateX(-50%)',
    zIndex: 9999
  },
  icon: {
    marginBottom: '5px',
    width: '45px',
    height: '45px'
  }
};

function showToastWindow(message, iconUrl) {
  if (!window._uni_toast_status.toastWin) {
    window._uni_toast_status.toastIcon = null;
    window._uni_toast_status.toastWin = document.createElement('div');

    window._uni_toast_status.toastWin.setAttribute('role', 'alert'); // support for ARIA, add tabindex for focus
    // https://developer.mozilla.org/zh-CN/docs/Web/HTML/Global_attributes/tabindex


    window._uni_toast_status.toastWin.setAttribute('tabindex', '-1');

    for (var key in styles.container) {
      window._uni_toast_status.toastWin.style[key] = styles.container[key];
    }

    window._uni_toast_status.toastContent = document.createElement('div');

    window._uni_toast_status.toastWin.appendChild(window._uni_toast_status.toastContent);

    document.body.appendChild(window._uni_toast_status.toastWin);
  } // 创建icon


  if (window._uni_toast_status.toastIcon && !iconUrl) {
    window._uni_toast_status.toastWin.removeChild(window._uni_toast_status.toastIcon);

    window._uni_toast_status.toastIcon = null;
  } else if (window._uni_toast_status.toastIcon && iconUrl) {
    window._uni_toast_status.toastIcon.setAttribute('src', iconUrl);
  } else if (!window._uni_toast_status.toastIcon && iconUrl) {
    window._uni_toast_status.toastIcon = document.createElement('img');

    window._uni_toast_status.toastIcon.setAttribute('src', iconUrl);

    for (var _key in styles.icon) {
      window._uni_toast_status.toastIcon.style[_key] = styles.icon[_key];
    }

    window._uni_toast_status.toastWin.insertBefore(window._uni_toast_status.toastIcon, window._uni_toast_status.toastContent);
  }

  window._uni_toast_status.toastContent.textContent = message;
  window._uni_toast_status.toastWin.style.transform = 'translateX(-50%)';
  window._uni_toast_status.toastWin.style.webkitTransform = 'translateX(-50%)';
}

function hideToastWindow() {
  setTimeout(function () {
    if (window._uni_toast_status.toastWin && window._uni_toast_status.toastWin.style) {
      window._uni_toast_status.toastWin.style.transform = 'translateX(-50%) scale(0.8)';
      window._uni_toast_status.toastWin.style.webkitTransform = 'translateX(-50%) scale(0.8)';
    }
  }, 0);
}

var innerToast = {
  hideTimer: null,
  show: function show() {
    // All messages had been toasted already, so remove the toast window,
    if (!window._uni_toast_status.queue.length) {
      if (window._uni_toast_status.toastWin) {
        // eslint-disable-next-line
        window._uni_toast_status.toastWin.parentNode.removeChild(window._uni_toast_status.toastWin);
      }

      window._uni_toast_status.toastWin = null;
      return;
    } // the previous toast is not ended yet.


    if (window._uni_toast_status.isProcessing) return;
    window._uni_toast_status.isProcessing = true;

    var toastInfo = window._uni_toast_status.queue.shift();

    try {
      showToastWindow(toastInfo.content, toastInfo.icon);
    } catch (e) {
      toastInfo.fail && toastInfo.fail(e);
      toastInfo.complete && toastInfo.complete(e);
    }

    innerToast.hideTimer = setTimeout(function () {
      toastInfo.success && toastInfo.success();
      toastInfo.complete && toastInfo.complete();
      innerToast.switchToNext();
    }, toastInfo.duration);
  },
  push: function push(options) {
    window._uni_toast_status.queue.push(options);

    innerToast.show();
  },
  // Switch to next message
  // This function will hide current, and call `show()` to display next
  // If queue is empty, DOM will be clear in `show()`
  switchToNext: function switchToNext() {
    hideToastWindow();
    window._uni_toast_status.isProcessing = false;
    setTimeout(function () {
      return innerToast.show();
    }, 500);

    if (innerToast.hideTimer) {
      clearTimeout(innerToast.hideTimer);
      innerToast.hideTimer = null;
    }
  }
};
var show$3 = normalize(function (options) {
  window._uni_toast_inner_toast = innerToast;
  window._uni_toast_status = window._uni_toast_status || {
    queue: [],
    isProcessing: false,
    toastWin: '',
    toastContent: '',
    toastIcon: ''
  };
  var type = options.type,
      content = options.content,
      duration = options.duration,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var iconMap = {
    success: 'https://gw.alicdn.com/imgextra/i1/O1CN01h684sE1Td4mwYyChK_!!6000000002404-2-tps-200-200.png',
    fail: 'https://gw.alicdn.com/imgextra/i1/O1CN01yOywus1et4ORJzafk_!!6000000003928-2-tps-200-200.png',
    none: ''
  };
  innerToast.push({
    content: content,
    duration: duration,
    icon: iconMap[type] || '',
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
});
var showToast$2 = show$3;

var hide$2 = normalize(function (options) {
  var success = options.success,
      fail = options.fail,
      complete = options.complete; // remove all queued messages

  try {
    if (!window._uni_toast_status) {
      success && success();
      complete && complete();
      return;
    }

    window._uni_toast_status.queue = [];

    window._uni_toast_inner_toast.switchToNext();

    success && success();
    complete && complete();
  } catch (e) {
    fail && fail(e);
    complete && complete(e);
  }
});
var hideToast$3 = hide$2;

var webModule = {
  show: showToast$2,
  hide: hideToast$3,
  showToast: showToast$2,
  hideToast: hideToast$3
};

var show$2 = normalize(function (options) {
  var type = options.type,
      content = options.content,
      duration = options.duration,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var iconMap = {
    success: 'success',
    loading: 'loading',
    none: 'none'
  }; // 快手image 不起作用。。

  ks.showToast({
    icon: iconMap[type] || 'none',
    title: content,
    duration: duration,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
});
var showToast$1 = show$2;

var hide$1 = normalize(function (options) {
  ks.hideToast(options);
});
var hideToast$2 = hide$1;

var kuaiShouModule = {
  show: showToast$1,
  hide: hideToast$2,
  showToast: showToast$1,
  hideToast: hideToast$2
};

var show$1 = normalize(function (options) {
  var type = options.type,
      content = options.content,
      duration = options.duration,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var iconMap = {
    success: 'success',
    loading: 'loading',
    none: 'none'
  };

  if (type === 'fail') {
    swan.showToast({
      image: 'https://gw.alicdn.com/imgextra/i2/O1CN01XzxlKk1GL8IyXoqEa_!!6000000000605-2-tps-200-200.png',
      title: content,
      duration: duration,
      success: function success() {
        _success && _success();
      },
      fail: function fail(res) {
        _fail && _fail(res);
      },
      complete: function complete(res) {
        _complete && _complete(res);
      }
    });
  } else {
    swan.showToast({
      icon: iconMap[type] || 'none',
      title: content,
      duration: duration,
      success: function success() {
        _success && _success();
      },
      fail: function fail(res) {
        _fail && _fail(res);
      },
      complete: function complete(res) {
        _complete && _complete(res);
      }
    });
  }
});
var showToast = show$1;

var hide = normalize(function (options) {
  swan.hideToast(options);
});
var hideToast$1 = hide;

var baiDuModule = {
  show: showToast,
  hide: hideToast$1,
  showToast: showToast,
  hideToast: hideToast$1
};

var show = function show(options) {
  if (isWeb) {
    return webModule.show(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.show(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.show(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.show(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.show(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.show(options);
  } else {
    throw new Error('Uni API：Toast暂不支持');
  }
};
var hideToast = function hideToast(options) {
  if (isWeb) {
    return webModule.hideToast(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.hideToast(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.hideToast(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.hideToast(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.hideToast(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.hideToast(options);
  } else {
    throw new Error('Uni API：Toast暂不支持');
  }
};

export { hideToast as h, show as s };
